export default {"src":"/_next/static/media/sendgrid.18f78525.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};